import type { AgentAvailableModel } from '@/types/agent'

/**
 * Whether the selected catalog id exists in the current available list.
 */
export function isModelIdInCatalog(selectedId: string, items: AgentAvailableModel[]): boolean {
  const id = String(selectedId || '').trim()
  if (!id) return false
  return items.some((m) => m.id === id)
}

/**
 * First catalog entry id, if any (used only for brand-new flows with no prior selection).
 */
export function getFirstCatalogModelId(items: AgentAvailableModel[]): string {
  return items[0]?.id ?? ''
}
